import { useReducer } from 'react';
import {
    RoleSortingField,
    SortingOrder,
    type RoleSortingRule,
    type RoleFilteringRule,
    type Maybe,
} from '../../../api/types';
import {
    type ExtendedPageState,
    type ExtendedPageAction,
    extendedReducer,
} from '../../../components/PaginatedTableWithContext';
import { TableSortingOrder, type SortOrderValue } from '../../../utilities/useSortAndFilterCache';

type SortRule = RoleSortingRule & SortOrderValue;
type State = ExtendedPageState & {
    sort?: SortRule;
    filter?: RoleFilteringRule;
};

export type SetSortAction = { type: 'setSort'; sortBy: Maybe<SortRule> };

export type SetFilterAction = { type: 'setFilter'; filterBy: Maybe<RoleFilteringRule> };

type Action = ExtendedPageAction | SetSortAction | SetFilterAction;

const reducer = (state: State, action: Action): State => {
    switch (action.type) {
        case 'setPage':
            return { ...state, page: action.page };

        case 'setPageSize':
            return { ...state, page: 0, pageSize: action.pageSize };

        case 'setSort':
            return { ...state, page: 1, sort: action.sortBy };

        case 'setFilter':
            return { ...state, page: 1, filter: action.filterBy };

        default:
            return extendedReducer(state, action);
    }
};

const useListReducer = (cache?: State) =>
    useReducer(reducer, {
        companyId: cache?.companyId,
        // default pagination
        page: cache?.page || 1,
        pageSize: cache?.pageSize || 10,

        // default sorting
        sort: cache?.sort || {
            field: RoleSortingField.DisplayName,
            order: SortingOrder.Asc,
            orderValue: TableSortingOrder.Asc,
        },

        // default filtering
        filter: cache?.filter || {},
    });

export default useListReducer;
